import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navigation from "./components/Navigation";
import HomePage from "./pages/HomePage";
import ExperiencePage from "./pages/ExperiencePage";
import ContactPage from "./pages/ContactPage";
import ShoutOutsPage from "./pages/ShoutOutsPage";
import BlogPage from "./pages/BlogPage";
import AffiliatePage from "./pages/AffiliatePage";

function App() {
  return (
    <div className="App gradient-bg min-h-screen">
      {/* Noise overlay for texture */}
      <div className="noise-overlay" />
      
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/experience" element={<ExperiencePage />} />
          <Route path="/affiliates" element={<AffiliatePage />} />
          <Route path="/shoutouts" element={<ShoutOutsPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
      
      <Toaster 
        position="bottom-right"
        toastOptions={{
          style: {
            background: 'rgba(20, 20, 20, 0.9)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            color: '#E0E0E0',
          },
        }}
      />
    </div>
  );
}

export default App;
